import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxPaginationModule } from 'ngx-pagination';

import { HeadquarterRoutingModule } from './headquarter-routing.module';
import { HeadquarterComponent } from './headquarter.component';
// import HeadroomModule
import { HeadroomModule } from '@ctrl/ngx-headroom';


import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION } from 'ngx-ui-loader';

//FOR LANGUAGE CONVERSION - STARTS
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
//FOR LANGUAGE CONVERSION - STARTS


import { HeaderComponent } from './includes/header/header.component';
import { FooterComponent } from './includes/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { LandingCarouselComponent } from './pages/home/landing-carousel/landing-carousel.component';
import { WhatsNewComponent } from './pages/home/whats-new/whats-new.component';
import { ObjectiveAreaComponent } from './pages/home/objective-area/objective-area.component';
import { MapAreaComponent } from './pages/home/map-area/map-area.component';
import { NewsTendersComponent } from './pages/home/news-tenders/news-tenders.component';
import { SocialMediaComponent } from './pages/home/social-media/social-media.component';
import { ClientsComponent } from './pages/home/clients/clients.component';
import { ProcurementComponent } from './pages/procurement/procurement.component';
import { WebsiteInnerLayoutComponent } from './pages/website-inner-layout/website-inner-layout.component';
import { WebsiteInnerSidenavComponent } from './pages/website-inner-sidenav/website-inner-sidenav.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { VideoGalleryComponent } from './pages/video-gallery/video-gallery.component';
import { ContentPageComponent } from './pages/content-page/content-page.component';
import { TendersComponent } from './pages/tenders/tenders.component';
import { NewsComponent } from './pages/news/news.component';
import { PressReleasesComponent } from './pages/press-releases/press-releases.component';
import { RecruitmentComponent } from './pages/recruitment/recruitment.component';
import { CircularComponent } from './pages/circular/circular.component';
import { AwardsComponent } from './pages/awards/awards.component';
import { SitemapComponent } from './pages/sitemap/sitemap.component';
import { SeeyourdepotComponent } from './pages/seeyourdepot/seeyourdepot.component';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { TimeFormatPipe } from './../pipes/time-format.pipe';
import { TendersDetailsComponent } from './pages/tenders-details/tenders-details.component';
import { DepotDetailsComponent } from './pages/depot-details/depot-details.component';
import { TendersDocumentsComponent } from './pages/tenders-documents/tenders-documents.component';
import { ContactusComponent } from './pages/contactus/contactus.component';
import { AnnualReportComponent } from './pages/annual-report/annual-report.component';
import { PressReleaseDetailsComponent } from './pages/press-release-details/press-release-details.component';
import { CircularDetailsComponent } from './pages/circular-details/circular-details.component';
import { DirectoryComponent } from './pages/directory/directory.component';
import { MailViewPipe } from '../pipes/mail-view.pipe';
import { NewsListComponent } from './pages/news-list/news-list.component';
import { BoardDirectorsComponent } from './pages/board-directors/board-directors.component';
import { AwardDetailsComponent } from './pages/award-details/award-details.component';
import { ShortNamePipe } from '../pipes/short-name.pipe';
import { HandbookComponent } from './pages/handbook/handbook.component';
import { WhatsNewDetailsComponent } from './pages/whats-new-details/whats-new-details.component';
import { FeedbackFormComponent } from './pages/feedback-form/feedback-form.component';
import { GalleryCategoryComponent } from './pages/gallery-category/gallery-category.component';
import { MousListComponent } from './pages/mous-list/mous-list.component';
import { NoticeOfBoardMeetingComponent } from './pages/notice-of-board-meeting/notice-of-board-meeting.component';
import { IndependentNonOfficialDirectorsComponent } from './pages/independent-non-official-directors/independent-non-official-directors.component';
import { ContentSearchComponent } from './pages/content-search/content-search.component';
import { SampleContentPageComponent } from './pages/sample-content-page/sample-content-page.component';
import { VigilanceContactDirectoryComponent } from './pages/vigilance-contact-directory/vigilance-contact-directory.component';
import { PurchaseContactDirectoryComponent } from './pages/purchase-contact-directory/purchase-contact-directory.component';
import  {ChatbotComponentComponent } from '../chatbot-component/chatbot-component.component';
import { OfficeOrderComponent } from './pages/office-order/office-order.component';
import { FullMonthPipe } from './../pipes/full-month.pipe';
import { EmployeeCornerComponent } from './pages/employee-corner/employee-corner.component';
import { EmployeeCornerDetailsComponent } from './pages/employee-corner-details/employee-corner-details.component';
import { OrganisationStructureComponent } from './pages/organisation-structure/organisation-structure.component';
import { PluginSideNavbarComponent } from './pages/plugin-side-navbar/plugin-side-navbar.component';
import { VideoCategoryComponent } from './pages/video-category/video-category.component';
import { PluginNavbarComponent } from './includes/plugin-navbar/plugin-navbar.component';
import { PluginBreadcrumbComponent } from './includes/plugin-breadcrumb/plugin-breadcrumb.component';
import { HospitalListFciHqrsComponent } from './pages/hospital-list-fci-hqrs/hospital-list-fci-hqrs.component';
import { MisKpiZonesComponent } from './pages/mis-kpi-zones/mis-kpi-zones.component';
import { BlogsComponent } from './pages/blogs/blogs.component';
import { BlogdetailsComponent } from './pages/blogdetails/blogdetails.component';
import { FeedbackComponent } from './pages/feedback/feedback.component';
import { ScreenReaderComponent } from './pages/screen-reader/screen-reader.component';
import { MisKpiRegionsComponent } from './pages/mis-kpi-regions/mis-kpi-regions.component';
import { ImmovablePropertyComponent } from './pages/immovable-property/immovable-property.component';
import { ContactDirectoryComponent } from './pages/contact-directory/contact-directory.component';

//FOR LANGUAGE CONVERSION - STARTS
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { NewslistArchiveComponent } from './pages/newslist-archive/newslist-archive.component';
import { PressreleaseArchiveComponent } from './pages/pressrelease-archive/pressrelease-archive.component';
import { CircularArchiveComponent } from './pages/circular-archive/circular-archive.component';
import { AwardArchiveComponent } from './pages/award-archive/award-archive.component';
import { TenderArchiveComponent } from './pages/tender-archive/tender-archive.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { AboutUsComponent } from './pages/home/about-us/about-us.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { GalleryArchiveComponent } from './pages/gallery-archive/gallery-archive.component';
import { VideoGalleryArchiveComponent } from './pages/video-gallery-archive/video-gallery-archive.component';
import { GalleryCategoryArchiveComponent } from './pages/gallery-category-archive/gallery-category-archive.component';
import { VideoCategoryArchiveComponent } from './pages/video-category-archive/video-category-archive.component';
import { ArchiveOfficeOrderComponent } from './pages/archive-office-order/archive-office-order.component';
import { SeeyourdepotnewComponent } from './pages/seeyourdepotnew/seeyourdepotnew.component';
export const HttpLoaderFactory= (http:HttpClient) =>{
  let siteURL= environment.siteURL;
  return new TranslateHttpLoader(http,siteURL+'assets/language/','.json')
}
//FOR LANGUAGE CONVERSION - ENDS

import { INgxSelectOptions, NgxSelectModule } from 'ngx-select-ex';
import { RecruitmentDetailsComponent } from './pages/recruitment-details/recruitment-details.component';
import { ContentDetailsComponent } from './pages/content-details/content-details.component';
import { WarehouseAssessmentComponent } from './pages/warehouse-assessment/warehouse-assessment.component';
const CustomSelectOptions: INgxSelectOptions = { // Check the interface for more options
    optionValueField: 'id',
    optionTextField: 'name'
};


// import { VideoCategoryComponent } from './pages/video-category/video-category.component';


const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#39b26f',
  bgsOpacity: 1,
  bgsSize: 50,
  bgsType: SPINNER.wanderingCubes,
  fgsColor: '#39b26f',
  fgsType: SPINNER.wanderingCubes,
  fgsPosition: POSITION.centerCenter,
  pbColor: '#39b26f',
  pbThickness: 5,
  blur: 10,
  overlayColor: 'rgba(1,22,11,.9)',
  text: 'LOADING...',
  textColor: '#39b26f'
  };


@NgModule({
  declarations: [
    HeadquarterComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LandingCarouselComponent,
    WhatsNewComponent,
    ObjectiveAreaComponent,
    MapAreaComponent,
    NewsTendersComponent,
    SocialMediaComponent,
    ClientsComponent,
    ProcurementComponent,
    WebsiteInnerLayoutComponent,
    WebsiteInnerSidenavComponent,
    GalleryComponent,
    VideoGalleryComponent,
    ContentPageComponent,
    TendersComponent,
    NewsComponent,
    PressReleasesComponent,
    RecruitmentComponent,
    CircularComponent,
    AwardsComponent,
    SitemapComponent,
    SeeyourdepotComponent,
    TimeFormatPipe,
    TendersDetailsComponent,
    DepotDetailsComponent,
    TendersDocumentsComponent,
    ContactusComponent,
    AnnualReportComponent,
    PressReleaseDetailsComponent,
    CircularDetailsComponent,
    DirectoryComponent,
    MailViewPipe,
    ShortNamePipe,
    NewsListComponent,
    BoardDirectorsComponent,
    AwardDetailsComponent,
    HandbookComponent,
    WhatsNewDetailsComponent,
    FeedbackFormComponent,
    GalleryCategoryComponent,
    MousListComponent,
    NoticeOfBoardMeetingComponent,
    IndependentNonOfficialDirectorsComponent,
    ContentSearchComponent,
    SampleContentPageComponent,
    VigilanceContactDirectoryComponent,
    PurchaseContactDirectoryComponent,
    ChatbotComponentComponent,
    OfficeOrderComponent,
    FullMonthPipe,
    EmployeeCornerComponent,
    EmployeeCornerDetailsComponent,
    OrganisationStructureComponent,
    PluginSideNavbarComponent,
    VideoCategoryComponent,
    PluginNavbarComponent,
    PluginBreadcrumbComponent,
    HospitalListFciHqrsComponent,
    MisKpiZonesComponent,
    BlogsComponent,
    BlogdetailsComponent,
    FeedbackComponent,
    ScreenReaderComponent,
    MisKpiRegionsComponent,
    ImmovablePropertyComponent,
    ContactDirectoryComponent,
    NewslistArchiveComponent,
    PressreleaseArchiveComponent,
    CircularArchiveComponent,
    AwardArchiveComponent,
    TenderArchiveComponent,
    ErrorPageComponent,
    AboutUsComponent,
    OverviewComponent,
    GalleryArchiveComponent,
    VideoGalleryArchiveComponent,
    GalleryCategoryArchiveComponent,
    VideoCategoryArchiveComponent,
    ArchiveOfficeOrderComponent,
    SeeyourdepotnewComponent,
    RecruitmentDetailsComponent,
    ContentDetailsComponent,
    WarehouseAssessmentComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    WebsiteInnerSidenavComponent,
    ClientsComponent,
  ],
  imports: [
    NgxPaginationModule,
    CommonModule,
    HeadquarterRoutingModule,
    HeadroomModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    //FOR LANGUAGE CONVERSION - STARTS
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    //FOR LANGUAGE CONVERSION - ENDS
    NgxSelectModule.forRoot(CustomSelectOptions)
  ] 
})
export class HeadquarterModule { }
